import { Tooltip } from '../../../components/common/Tooltip';

interface Props {
  imageUrl: string;
  savedCloud: boolean;
  savedTemp: boolean;
  pendingCloud: boolean;
  pendingTemp: boolean;
  onSaveCloud: (imageUrl: string) => void;
  onSaveTemp: (imageUrl: string) => void;
  /** ツールチップ・alt の動詞 (Amazon=保存 / マニュアル=アップロード) */
  verb?: '保存' | 'アップロード';
}

/**
 * 商品画像の「共有フォルダ / 個人フォルダに保存」ボタン群。
 * Amazon / マニュアル商品詳細ページの各画像スロットヘッダで共用する。
 */
export function SaveToFolderButtons({
  imageUrl,
  savedCloud,
  savedTemp,
  pendingCloud,
  pendingTemp,
  onSaveCloud,
  onSaveTemp,
  verb = '保存',
}: Props) {
  return (
    <div className="save-buttons-group">
      <Tooltip content={savedCloud ? `共有フォルダに${verb}済み` : `共有フォルダに${verb}`}>
        <button
          className={`image-save-button cloud-button ${savedCloud ? 'saved' : ''}`}
          onClick={() => onSaveCloud(imageUrl)}
          disabled={pendingCloud || savedCloud}
        >
          <img src="/cloud_add.svg" alt={verb} />
        </button>
      </Tooltip>
      <Tooltip content={savedTemp ? `個人フォルダに${verb}済み` : `個人フォルダに${verb}`}>
        <button
          className={`image-save-button folder-button ${savedTemp ? 'saved' : ''}`}
          onClick={() => onSaveTemp(imageUrl)}
          disabled={pendingTemp || savedTemp}
        >
          <img src="/folder_plus.svg" alt={verb} />
        </button>
      </Tooltip>
    </div>
  );
}
